import { useQuery } from "@tanstack/react-query";
import {
	extraGeosFromReference,
	getGeoReference,
	priorityGeosFromReference,
	type GeoReference,
} from "../../../shared/api/references/geo";
import { PRIORITY_GAMBLING_GEOS } from "../../../shared/constants/priority-gambling-geos";

export const geoReferenceQueryKey = ["references", "geo"] as const;

const FALLBACK_REFERENCE: GeoReference = Object.fromEntries([
	...PRIORITY_GAMBLING_GEOS.map((code, index) => [
		code,
		100 - index,
	] as const),
]);

export function useGeoReference(enabled = true) {
	return useQuery({
		queryKey: geoReferenceQueryKey,
		queryFn: getGeoReference,
		enabled,
		staleTime: 15 * 60 * 1000,
		gcTime: 60 * 60 * 1000,
	});
}

/** Priority chips: live reference when loaded, else static DAI-1168 fallback. */
export function usePriorityGamblingGeos(enabled = true): string[] {
	const query = useGeoReference(enabled);
	if (query.data) return priorityGeosFromReference(query.data);
	return [...PRIORITY_GAMBLING_GEOS];
}

/** Non-priority codes for the searchable "+ GEO" list. */
export function useExtraGamblingGeos(enabled = true): string[] {
	const query = useGeoReference(enabled);
	if (query.data) return extraGeosFromReference(query.data);
	return [];
}

export function useGeoReferenceFallback(): GeoReference {
	const query = useGeoReference();
	return query.data ?? FALLBACK_REFERENCE;
}
